import React from 'react';
import { configureAxiosJWTInterseptors } from '@axmit/axios-patch-jwt';
import axios from 'axios';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { IAsyncStorage, WebStorageDecorator } from 'universal-storage';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import window from 'global/window';
import { errorMapper } from '@axmit/error-helper';
import { envConfig } from 'common/config/env.config';
import { history, store } from 'app/store';
import 'app/assets/sass/index.scss';
import { App } from 'app/App';

// Sentry initialization
Sentry.init({
  dsn: envConfig.SENTRY_DSN || envConfig.REACT_APP_SENTRY_DSN,
  environment: envConfig.NODE_ENV,
  ignoreErrors: ['ResizeObserver loop limit exceeded'],
});

window.checkSentry = (text?: string) => {
  const msg = `Sentry successfully connected. Config: ${JSON.stringify(envConfig)} ${new Date()}. Test string: ${text}`;
  console.log('Go to slack channel and check an error with message: ');
  console.log(msg);
  Sentry.captureException(msg);
};

// Axios initialization
const storage: IAsyncStorage = new WebStorageDecorator(localStorage);

export const axiosConfig = {
  storage,
  axios,
  refreshTokenEndpoint: '/auth',
  // onSaveCreds: (creds: ICreds) => {
  //   store.dispatch({ type: getSuccessType('auth', 'model', EActionsTypes.add), payload: creds });
  // }
};

configureAxiosJWTInterseptors(axiosConfig);

axios.defaults.baseURL = `/api`;
axios.interceptors.request.use((config) => ({
  ...config,
  headers: {
    'Source-Service': 'manager',
    'x-client-version': envConfig.RELEASE_VERSION || envConfig.REACT_APP_RELEASE_VERSION || '',
    ...config.headers,
  },
}));
axios.interceptors.response.use(
  (response) => response.data,
  (error) => errorMapper(error)
);
// Render Setup

const MOUNT_NODE = document.getElementById('root');

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  MOUNT_NODE
);
